import EventEmitter from 'EventEmitter';

const events = {
  OPEN_BIDDING: '@bidding/OPEN_BIDDING',
  BIDDING_VIEWED: '@bidding/BIDDING_VIEWED',
};

const BiddingEventEmitter = new EventEmitter();

export default BiddingEventEmitter;
export { events };
